// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c8c1e269","404":"a4ad32b2","787":"0b870f35"}[chunkId] + ".chunk.js";
};